<template>
  <div class="listContainer">
    <zr-page-table
      ref="pageTable"
      class="page-box"
      :loading-show="listLoading"
      :data="list"
      :columns="realCols"
      :page-sizes="pageSizes"
      :total="total"
      stripe=""
      @refresh-page="fetchPageData"
    >
      <template v-slot:status="{ row }">
        <div style="text-align: left">
        <span v-if="row.status === 'postSend'" class="waiting"
          ><zr-icon icon="clock" :key="row.status"></zr-icon> 待审核</span
        >
        <span v-if="row.status === 'unfit'" class="notPass"
          ><zr-icon icon="hands-helping" :key="row.status"></zr-icon> 很遗憾的通知您未能进入下一阶段，感谢您对我院的关注，期待您下次投递，欢迎您继续关注或投递其他岗位！
        </span>
        <span v-if="row.status === 'close'" class="over"
        ><zr-icon icon="lock" :key="row.status"></zr-icon> 感谢您对我院的关注，该岗位已完成招聘
        </span>
        <span v-if="row.status === 'postSending'" class="primarySelect"
          ><zr-icon icon="star-half-alt" :key="row.status"></zr-icon> 审核中</span
        >
        <span v-if="row.status === 'fit'" class="pass"
        ><zr-icon icon="star-half-alt" :key="row.status"></zr-icon> 恭喜您进入下一阶段，如有进一步消息我们的工作人员会通过邮件、短信、电话通知您，请确保联系方式畅通！</span>
        </div>
      </template>
    </zr-page-table>
  </div>
</template>

<script>
import { getResumePage } from "@api/recruit/applicant/positionList";
import { searchBasicData } from "@api/framework/basicData/dataDictType";

var nowYear = new Date().getFullYear();
import { defaultPageSizes } from "@/config/settings";
import commFormat from "zr-util/src/utils/comm/commFormat";
import { mapGetters } from "vuex";
import { getDeptList } from "@/api/framework/org/depts";
export default {
  name: "PositionList",
  data() {
    return {
      list: [],
      listLoading: true,
      total: 0,
      pageSizes: defaultPageSizes,
      columns: [
        { code: "name", name: "姓名" },
        {
          code: "sex",
          name: "性别",
          formatter: (row, value) => {
            if (value == "female") {
              return "女";
            } else {
              return "男";
            }
          },
        },
        { code: "age", name: "年龄" },
        { code: "phase", name: "学历" },
        { code: "studyField", name: "专业" },
        { code: "university", name: "毕业学校" },
        {
          code: "postType",
          name: "职位类型",
          formatter: (row, value) => {
            for (let i = 0, len = this.basicDatas.length; i < len; i++) {
              if (value == this.basicDatas[i].code) {
                return this.basicDatas[i].name;
              }
            }
            return value;
          },
          width: 100,
          fixed: "left",
        },
        { code: "postName", name: "应聘职位名称", width: 200 },
        {
          code: "publishDeptCode",
          name: "投递单位",
          formatter: (row, value) => {
            for (let i = 0, len = this.deptDatas.length; i < len; i++) {
              if (value == this.deptDatas[i].deptCode) {
                return this.deptDatas[i].name;
              }
            }
            return value;
          },
          width: 150,
        },
        {
          code: "sendDate",
          name: "投递日期",
          formatter: (row, value) => {
            if (typeof value == "string") {
              return value.substring(0, 10);
            } else {
              return commFormat.formatDate(value, "yyyy-MM-dd");
            }
          },
          width: 100,
        },
        {
          code: "status",
          name: "审核情况",
          needDrawCell: true,
          width: 300,
          fixed: "right",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      device: "settings/device",
      userPhone: "user/userPhone",
    }),
    realCols() {
      return this.device == "mobile" ? this.columns.slice(6) : this.columns;
    },
  },
  async created() {
    await this.initBasicDatas();
    await this.initDeptDatas();
    await this.fetchPageData({ pageSize: defaultPageSizes[0], pageIndex: 1 });
  },
  methods: {
    getIconByStatus(status) {
      if (status == "waiting") {
        return "clock";
      } else if (status == "pass") {
        return "star";
      } else if (status == "notPass") {
        return "hands-helping";
      } else if (status == "primarySelect") {
        return "star-half-alt";
      }
      return "user";
    },
    async fetchPageData(pageInfo) {
      this.listLoading = true;
      //通过简历resumeId查询所有的投递信息
      let res = await getResumePage({
        ...pageInfo,
        resumeId: this.$route.query.resumeId,
      });
      if (res.success) {
        const data = res.data;
        this.list = data.data;
        this.list = this.list.map((value) => {
          var age;
          if (value.birthday && value.birthday.length > 4) {
            var birthday = value.birthday.substring(0, 4);
            //计算年龄
            age = nowYear - parseInt(birthday);
          }
          value.age = age;
          return value;
        });
        this.total = data.total;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
      setTimeout(() => {
        this.listLoading = false;
      }, 300);
    },
    async initBasicDatas() {
      const res = await searchBasicData({ typeCode: "postType" });
      if (res.success) {
        this.basicDatas = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    async initDeptDatas() {
      const res = await getDeptList();
      if (res.success) {
        this.deptDatas = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "public/static/scss/commTableLayouts";
.page-box {
  height: $base-app-main-height;
}
.waiting {
  color: $base-font-color;
}
.pass {
  color: $base-color-green;
}
.notPass {
  color: $base-color-red;
}
.primarySelect {
  color: $base-color-blue;
}
.over {
  color: $base-color-black;
}
</style>
